import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent, Chip, Container,
    FormControl,
    Grid, IconButton, InputAdornment,
    InputLabel,
    MenuItem, Paper,
    Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField, Tooltip, Typography
} from "@mui/material";
import {useSelector} from "react-redux";

import Loading from "../../components/Common/Loading";
import {
    useCreateAudienceMutation,
    useGetAllAudiencesQuery,
    useUpdateAudienceMutation
} from "../../core/api/audience-api";
import {isAdmin} from "../../core/utils/commonUtils";

import {
    useCreateCampaignMutation,
    useGetAllCampaignsQuery,
    useGetAnalyticsQuery,
    useGetCampaignQuery,
    useScheduleCampaignMutation,
    useStopCampaignMutation,
    useUpdateCampaignMutation
} from "../../core/api/campaign-api";
import CreateCampaignModal from "./CreateCampaignPage";
import dayjs from "dayjs";

import {
    PlayArrow,
    Stop,
    Edit,
    Cancel,
    Analytics, TrendingUp, Send, TouchApp
} from "@mui/icons-material";
import {useParams} from "react-router";
import {LineChart} from "@mui/x-charts";
import {getCtr} from "../../core/utils/audienceUtils";
import Audience from "../Audience/AudienceInfo/Audience";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function CampaignAnalytics() {

    const { id } = useParams(); // Получаем id из URL параметров

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetCampaignQuery(id)

    const {
        data: audiences,
        isLoadingA,
        isSuccessA,
        isErrorA,
        isFetchingA,
        errorA
    } = useGetAllAudiencesQuery()


    const getSelectedAudienceData = () => {
        if (!audiences || !data) return null;
        return audiences.find(audience => audience.id === data.audienceId);
    };

    const selectedData = getSelectedAudienceData();

    const formatNumber = (num) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toLocaleString();
    };

    const formatCTR = (ctr) => {
        return ctr.toFixed(1) + '%';
    };


    const xLabels = data!==undefined ? data.statistics.map((item) => {
        return new Date(item.date[0], item.date[1] - 1, item.date[2]);
    }) : [];
    const sentData = data!==undefined ? data.statistics.map((item) => item.sent) : [];
    const clickedData = data!==undefined ? data.statistics.map((item) => item.clicked) : [];

    console.log('xLabels')
    console.log(xLabels)

    const sendTypeTitles = {IMMEDIATE:'Immediate',LOCAL_TIME:'Local Time',ACTIVE_TIME:'Active Time'}

    const statusColor = {
        "DRAFT":"default",
        "ACTIVE":"success",
        "SCHEDULED":"warning",
        "COMPLETED":"primary",
        "CANCELLED":"error",
    }

    const getFormattedDate = (params) => {
        if (Array.isArray(params.value)) {
            const [year, month, day, hour, minute] = params.value;
            return dayjs.utc(new Date(Date.UTC(year, month - 1, day, hour, minute))).format("YYYY-MM-DD HH:mm:ss");
        }
    }

    return <Container>
        <Loading isLoading={isLoading} error={error} isError={error}>
            {data !== undefined && <>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <h3>Analytics {data.title}</h3>
                </Box>

                <Grid container spacing={3}>
                    <Grid item size={4}>
                        <Card>
                            <CardContent style={{paddingBottom:'16px', display: 'flex', alignItems: 'center'}}>
                                <Box sx={{ mr: 1 }}>CTR: <b> {getCtr(data)}</b></Box>
                                <Tooltip title={
                                    <Box sx={{ p: 1 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            Процент игроков, кликнувших на push<br />
                                            <strong>clicks / delivered × 100%</strong><br />
                                            Обновление каждые 5 минут
                                        </Typography>
                                    </Box>
                                } placement="bottom-start">
                                    <InfoOutlinedIcon sx={{ fontSize: 20, color: 'text.secondary', cursor: 'help' }} />
                                </Tooltip>
                            </CardContent>
                        </Card>
                    </Grid>


                    <Grid item size={5}>
                        <Card>
                            <CardContent style={{paddingBottom:'16px'}}>
                                {getFormattedDate({value:data.deliveryTime})}
                                &nbsp;
                                {sendTypeTitles[data.deliveryType]}
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item size={3}>
                        <Card>
                            <CardContent sx={{pb:0,mb:0, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} style={{paddingBottom:'13px',paddingTop:'13px'}}>

                                <Chip
                                    label={data.status.toLowerCase()}
                                    color={statusColor[data.status]}
                                    variant="contained"
                                    size="small"
                                />

                                <Tooltip title={
                                    <Box sx={{ p: 1 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            <strong>COMPLETED</strong> - Раздача кампании полностью завершена, все пуши отправлены
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            <strong>CANCELLED</strong> - кампания отменена, отправка пушей завершается
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            <strong>SCHEDULED</strong> - Кампания запланирована, формируется список игроков, которые должны получить пуш
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            <strong>ACTIVE</strong> - Раздача пушей началась, список игроков, которые должны получить пуш уже сформирован
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>DRAFT</strong> - Черновик
                                        </Typography>
                                    </Box>
                                } placement="bottom-end">
                                    <InfoOutlinedIcon sx={{ ml: 1, fontSize: 20, color: 'text.secondary', cursor: 'help' }} />
                                </Tooltip>
                            </CardContent>
                        </Card>
                    </Grid>

                </Grid>

                <Box sx={{ mx: 'auto' }}>
                    <Grid container spacing={3}>
                        {/*{metrics.map((metric, index) => (*/}
                        {/*    <Grid item xs={12} md={4} key={index}>*/}
                        {/*        <Card*/}
                        {/*            elevation={4}*/}
                        {/*            sx={{*/}
                        {/*                borderRadius: 2,*/}

                        {/*            }}*/}
                        {/*        >*/}
                        {/*            <CardContent sx={{ textAlign: 'center', py: 5 }}>*/}
                        {/*                <Avatar*/}
                        {/*                    sx={{*/}
                        {/*                        mx: 'auto',*/}
                        {/*                        mb: 2,*/}
                        {/*                        bgcolor: `${metric.color}20`,*/}
                        {/*                        color: metric.color,*/}
                        {/*                        width: 56,*/}
                        {/*                        height: 56,*/}
                        {/*                    }}*/}
                        {/*                >*/}
                        {/*                    {metric.icon}*/}
                        {/*                </Avatar>*/}

                        {/*                <Typography*/}
                        {/*                    variant="subtitle1"*/}
                        {/*                    sx={{ color: '#666', textTransform: 'uppercase', fontWeight: 600 }}*/}
                        {/*                >*/}
                        {/*                    {metric.title}*/}
                        {/*                </Typography>*/}

                        {/*                <Typography variant="h3" sx={{ color: metric.color, fontWeight: 'bold' }}>*/}
                        {/*                    {metric.value}*/}
                        {/*                </Typography>*/}

                        {/*            </CardContent>*/}
                        {/*        </Card>*/}
                        {/*    </Grid>*/}
                        {/*))}*/}
                    </Grid>


                </Box>

                <Card>
                    <CardContent>
                        <LineChart
                            xAxis={[
                                {
                                    data: xLabels,
                                    label: 'Date',
                                    // Если xLabels это даты, можно указать форматирование
                                    scaleType: 'band',
                                    // Форматирование меток оси X
                                    tickFormatter: (value) => {
                                        return dayjs(value).format('DD.MM.YYYY');
                                    },

                                },
                            ]}
                            series={[
                                {
                                    data: sentData,
                                    label: 'Sent',
                                },
                                {
                                    data: clickedData,
                                    label: 'Clicked',
                                },
                            ]}
                            height={400}
                        />
                    </CardContent>
                </Card>

                <Grid container spacing={3}>
                    <Grid item size={4}>
                        <Card>
                            <CardContent>
                                <Typography variant="subtitle1" component="h4" gutterBottom>
                                    Target Size:
                                    <Chip
                                        label={selectedData?.statistics===null||selectedData?.statistics?.targetSize===null?'calculating...':parseInt(selectedData?.statistics?.targetSize)}
                                        color="primary"
                                        size="small"
                                        sx={{ ml: 1 }}
                                    />
                                </Typography>

                                {selectedData!==null&&<Audience key={1} audience={selectedData.filter}></Audience>}

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item size={8}>
                        <Card>
                            <CardContent>
                                <h4>Messages</h4>
                                <Table>
                                    {data.messages.map(message => {
                                        return <TableRow>
                                            <TableCell>{message.locale}</TableCell>
                                            <TableCell>{message.title}</TableCell>
                                            <TableCell>{message.body}</TableCell>
                                        </TableRow>
                                    })}
                                </Table>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

            </>}
        </Loading>

    </Container>
}